import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import HomePageTwo from "./pages/HomePageTwo";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import CustomerProfilePage from "./pages/CustomerProfilePage";
import AddressesPage from "./pages/AddressesPage";
import OrdersPage from "./pages/OrdersPage";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import OrderFailedPage from "./pages/OrderFailedPage";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SozlesmePage from "./pages/SozlesmePage";
import IadePolitikasiPage from "./pages/IadePolitikasiPage";
import CustomPackagePage from "./pages/CustomPackagePage";

export const App = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <RouteScrollToTop />
          <PhosphorIconInit />
          <CartProvider>
          <style>{`
            /* Enhanced button hover effects */
            .btn:not(:disabled):hover {
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }

            .btn {
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }

            /* Link hover improvements */
            a:not(.btn) {
              transition: color 0.2s ease;
            }

            /* Enhanced input focus effects */
            input:not([type="checkbox"]):not([type="radio"]),
            textarea,
            select {
              transition: all 0.3s ease;
            }

            input:not([type="checkbox"]):not([type="radio"]):focus,
            textarea:focus,
            select:focus {
              transform: translateY(-2px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
            }

            /* Quantity button improvements */
            .quantity__minus,
            .quantity__plus {
              transition: all 0.2s ease;
            }

            .quantity__minus:hover,
            .quantity__plus:hover {
              transform: scale(1.1);
            }

            .quantity__minus:active,
            .quantity__plus:active {
              transform: scale(0.95);
            }
          `}</style>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
          />
          <Routes>
            <Route exact path="/" element={<HomePageOne />} />
            <Route exact path="/index-two" element={<HomePageTwo />} />
            <Route exact path="/shop" element={<ShopPage />} />
            <Route exact path="/kendin-sec" element={<CustomPackagePage />} />
            <Route
              exact
              path="/product-details"
              element={<ProductDetailsPageOne />}
            />
            <Route
              exact
              path="/product-details/:id"
              element={<ProductDetailsPageOne />}
            />
            <Route exact path="/cart" element={<CartPage />} />
            <Route
              exact
              path="/checkout"
              element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route exact path="/order-success" element={<OrderSuccessPage />} />
            <Route exact path="/order-failed" element={<OrderFailedPage />} />
            <Route exact path="/login" element={<LoginPage />} />
            <Route exact path="/register" element={<RegisterPage />} />
            <Route
              exact
              path="/profile"
              element={
                <ProtectedRoute>
                  <CustomerProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/addresses"
              element={
                <ProtectedRoute>
                  <AddressesPage />
                </ProtectedRoute>
              }
            />
            <Route
              exact
              path="/orders"
              element={
                <ProtectedRoute>
                  <OrdersPage />
                </ProtectedRoute>
              }
            />
            <Route exact path="/blog" element={<BlogPage />} />
            <Route exact path="/blog-details" element={<BlogDetailsPage />} />
            <Route exact path="/contact" element={<ContactPage />} />
            <Route exact path="/sozlesme" element={<SozlesmePage />} />
            <Route exact path="/iade-politikasi" element={<IadePolitikasiPage />} />
          </Routes>
        </CartProvider>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
};
